module.exports = __webpack_public_path__ + "img/sfq-h3.e4dd1b49.png";